import { useMemo } from 'react'

import { useParams } from 'react-router-dom'

import { AppRouteParams } from '@app/types'

export const useConversationID = (): number | string | null => {
  const { conversationId } = useParams<AppRouteParams>()

  return useMemo(() => {
    if (!conversationId) {
      return null
    }

    const numericId = Number(conversationId)
    if (!Number.isNaN(numericId)) {
      return numericId
    }

    return conversationId
  }, [conversationId])
}
